import { GetOrganisationQuery } from '../../../../view/components/__generated__/organisation.generated';
import { MemberTableProps, MembersTable } from '../../../../components/MembersTable';

export type TeamMemberDataType =
	GetOrganisationQuery['organisation']['teams'][0]['members'][0]['organisationMember']['user'] & {
		teamRole: GetOrganisationQuery['organisation']['teams'][0]['members'][0]['role'];
		memberId: GetOrganisationQuery['organisation']['members'][0]['id'];
	};

export const TeamMembersTable = ({
	data,
	columnsConfig,
	renderRowActions,
}: MemberTableProps<TeamMemberDataType>) => (
	<MembersTable data={data} columnsConfig={columnsConfig} renderRowActions={renderRowActions} />
);
